import React from 'react';
import i18next from 'i18next';
import queryString from 'query-string';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import moment from 'moment';

import { withTheme } from '@material-ui/core/styles';

import { getFormat, twoDigits, makeGraph } from 'lib/commonLib';
import { dailyCategoryRoasGraph } from 'lib/api/time';

import CurrentStatus from 'components/atoms/CurrentStatus';
import OutlinedButton from 'components/atoms/OutlinedButton';
import ChartButtonWrap from 'components/molecules/ChartButtonWrap';
import ContentsWrap from 'components/molecules/ContentsWrap';
import InfoTitleArea from 'components/molecules/MbTable/InfoTitleArea';
import SwitchingArea from 'components/organisms/SwitchingArea';
import MultiplexChart from 'components/organisms/Chart/MultiplexChart';

const graphList = [
  {
    title: i18next.t('지출금액'),
    data: { bar: ['ADVRTS_AMT'] },
    yAxisData: {
      left: { ADVRTS_AMT: true },
      right: {},
    },
    referenceLine: {
      ADVRTS_AMT: {
        type: 'average',
        label: i18next.t('지출금액'),
        visibleValue: true,
        color: '#f66172',
      },
    },
  },
  {
    title: i18next.t('노출'),
    data: { bar: ['PAR_EPRS_CNT'] },
    yAxisData: {
      left: { PAR_ERPS_CNT: true },
      right: {},
    },
    referenceLine: {
      PAR_EPRS_CNT: {
        type: 'average',
        label: i18next.t('노출'),
        visibleValue: true,
        color: '#f66172',
      },
    },
  },
  {
    title: 'CTR',
    data: { bar: ['CLICK_RATE'] },
    yAxisData: {
      left: { CLICK_RATE: true },
      right: {},
    },
    referenceLine: {
      CLICK_RATE: {
        type: 'average',
        label: i18next.t('CTR'),
        visibleValue: true,
        color: '#f66172',
      },
    },
  },
  {
    title: i18next.t('세션ROAS'),
    data: { bar: ['SESSION_ROAS'] },
    yAxisData: {
      left: { SESSION_ROAS: true },
      right: {},
    },
    referenceLine: {
      SESSION_ROAS: {
        type: 'average',
        label: i18next.t('세션ROAS'),
        visibleValue: true,
        color: '#f66172',
      },
    },
  },
  {
    title: i18next.t('쇼핑ROAS'),
    data: { bar: ['TRGT_ROAS'] },
    yAxisData: {
      left: { TRGT_ROAS: true },
      right: {},
    },
    referenceLine: {
      TRGT_ROAS: {
        type: 'average',
        label: i18next.t('쇼핑ROAS'),
        visibleValue: true,
        color: '#f66172',
      },
    },
  },
  {
    title: i18next.t('직접ROAS'),
    data: { bar: ['DIRECT_ROAS'] },
    yAxisData: {
      left: { DIRECT_ROAS: true },
      right: {},
    },
    referenceLine: {
      DIRECT_ROAS: {
        type: 'average',
        label: i18next.t('직접ROAS'),
        visibleValue: true,
        color: '#f66172',
      },
    },
  },
  {
    title: i18next.t('총ROAS'),
    data: { bar: ['ROAS'] },
    yAxisData: {
      left: { ROAS: true },
      right: {},
    },
    referenceLine: {
      ROAS: {
        type: 'average',
        label: i18next.t('총ROAS'),
        visibleValue: true,
        color: '#f66172',
      },
    },
  },
  {
    title: i18next.t('클릭수'),
    data: { bar: ['CLICK_CNT'] },
    yAxisData: {
      left: { CLICK_CNT: true },
      right: {},
    },
    referenceLine: {
      CLICK_CNT: {
        type: 'average',
        label: i18next.t('클릭수'),
        visibleValue: true,
        color: '#f66172',
      },
    },
  },
  {
    title: i18next.t('전환수'),
    data: { bar: ['ORDER_CNT'] },
    yAxisData: {
      left: { ORDER_CNT: true },
      right: {},
    },
    referenceLine: {
      ORDER_CNT: {
        type: 'average',
        label: i18next.t('전환수'),
        visibleValue: true,
        color: '#f66172',
      },
    },
  },
];

class CategoryStatisticsGraph extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      graphData: [],
      infoMessage: '',
      loading: false,
      error: false,
      noData: false,
    };
  }

  getData = () => {
    const { params, locale, t, location } = this.props;
    const { uri } = queryString.parse(location.search);

    const { sDate, eDate } = params;
    const format = getFormat(locale);
    this.setState({
      ...this.state,
      loading: true,
      error: false,
      noData: false,
      infoMessage: t('까지의 통계 그래프입니다.', {
        date: t('term', {
          startDate: moment(sDate).format(format),
          endDate: moment(eDate).format(format),
        }),
      }),
    });
    dailyCategoryRoasGraph({ ...params, uri })
      .then((response) => {
        const { data } = response.data;
        if (data.length === 0) {
          this.setState({
            ...this.state,
            loading: false,
            error: false,
            noData: true,
          });
        } else {
          this.setState({
            ...this.state,
            primitiveData: data,
            loading: false,
          });
          this.handleChangeGraph(graphList[0], 0)();
        }
      })
      .catch((error) => {
        this.setState({
          ...this.state,
          loading: false,
          error: true,
        });
      });
  };

  componentDidMount() {
    this.getData();
  }

  componentDidUpdate(prevProps) {
    const { params: prevParams } = prevProps;
    const { params } = this.props;

    if (JSON.stringify(prevParams) !== JSON.stringify(params)) {
      this.getData();
    }
  }

  /**
   * 새로고침
   */
  handleRefesh = () => {
    this.getData();
  };

  // 월 일 or 일 반환
  makeLabel = (onlyDay) => (originalDate) => {
    const { t, theme } = this.props;
    const dateObj = moment(originalDate, 'YYYYMMDD');
    const month = twoDigits(dateObj.month() + 1);
    const date = dateObj.date();
    const day = dateObj.day();
    let color = '';

    if (day === 0) {
      color = theme.palette.common.red;
    } else if (day === 6) {
      color = theme.palette.common.blue;
    }

    return onlyDay ? (
      `${twoDigits(date)}${t('일')}`
    ) : (
      <span style={{ color }}>{`${t(month + '월')} ${twoDigits(date)}${t(
        '일'
      )}`}</span>
    );
  };

  xAxisTick = (tickProps) => {
    const { theme } = this.props;
    const { x, y, payload } = tickProps;
    const { value } = payload;
    const dateObj = moment(value, 'YYYYMMDD');
    const day = dateObj.day();

    const dayStr = this.makeLabel(true)(value);
    let fill = '';
    //Sunday as 0 and Saturday as 6.
    if (day === 0) {
      fill = theme.palette.common.red;
    } else if (day === 6) {
      fill = theme.palette.common.blue;
    }

    return (
      <text x={x} y={y + 10} fill={fill} textAnchor="middle">
        {dayStr}
      </text>
    );
  };

  /**
   * 버튼 클릭하여 그래프 데이터 변경
   * graphData json, index
   */
  handleChangeGraph =
    (
      {
        title,
        data,
        yAxisData,
        customizeData: customize,
        isPercent = false,
        referenceLine,
      },
      index
    ) =>
    (e) => {
      const { primitiveData } = this.state;

      if (typeof data !== 'undefined') {
        const {
          graphData,
          dataKeys,
          customizeData,
          keyLabel,
          stackId,
          referenceData,
        } = makeGraph({ data, customize, primitiveData, referenceLine });
        const result = (
          <MultiplexChart
            width="100%"
            xAxisTick={this.xAxisTick}
            makeLabel={this.makeLabel(false)}
            data={graphData}
            dataKeys={dataKeys}
            customizeData={customizeData}
            keyLabel={keyLabel}
            stackId={stackId.length !== 0 ? stackId.join('$') : null}
            yAxisData={yAxisData}
            legend
            title={title}
            isPercent={isPercent}
            key={title}
            referenceLine={referenceData}
          />
        );

        this.setState({
          ...this.state,
          curGraphComponent: result,
          selectedIdx: index,
        });
      }
    };

  render() {
    const { handleRefesh, handleChangeGraph } = this;
    const { t } = this.props;
    const {
      infoMessage,
      curGraphComponent,
      selectedIdx,
      primitiveData,
      loading,
      error,
      noData,
    } = this.state;

    return (
      <SwitchingArea
        title={
          <>
            <InfoTitleArea
              title={t('카테고리별 데이터 그래프')}
              tooltipTitle={infoMessage}
              iconType="fainfoCircle"
              iconColor="graph"
            />
          </>
        }
        handleRefesh={handleRefesh}
      >
        {loading || noData || error ? (
          <CurrentStatus
            type={loading ? 'loading' : noData ? 'noData' : error && 'error'}
          />
        ) : (
          <>
            <ChartButtonWrap>
              {graphList.map((item, index) => {
                return (
                  <OutlinedButton
                    key={item.title}
                    onClick={handleChangeGraph(item, index)}
                    selected={selectedIdx === index}
                    disabled={!Boolean(primitiveData)}
                  >
                    {item.title}
                  </OutlinedButton>
                );
              })}
            </ChartButtonWrap>
            <ContentsWrap contentsCount={1}>{curGraphComponent}</ContentsWrap>
          </>
        )}
      </SwitchingArea>
    );
  }
}

export default withRouter(
  withTranslation()(
    connect(
      ({ locale }) => ({
        locale: locale.locale,
      }),
      null
    )(withTheme(CategoryStatisticsGraph))
  )
);
